/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IAccountClient {
    /**
     * @return OK
     */
    get(debtorNumber: string): Promise<ApiResultOfIEnumerableOfAccountDto>;
}

export class AccountClient implements IAccountClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44326";

    }

    /**
     * @return OK
     */
    get(debtorNumber: string , cancelToken?: CancelToken | undefined): Promise<ApiResultOfIEnumerableOfAccountDto> {
        let url_ = this.baseUrl + "/api/Account?";
        if (debtorNumber === undefined || debtorNumber === null)
            throw new Error("The parameter 'debtorNumber' must be defined and cannot be null.");
        else
            url_ += "DebtorNumber=" + encodeURIComponent("" + debtorNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ApiResultOfIEnumerableOfAccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfIEnumerableOfAccountDto.fromJS(resultData200);
            return Promise.resolve<ApiResultOfIEnumerableOfAccountDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("NotFound", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfIEnumerableOfAccountDto>(<any>null);
    }
}

export interface IHealthClient {
    /**
     * @return OK
     */
    get(): Promise<any>;
}

export class HealthClient implements IHealthClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44326";

    }

    /**
     * @return OK
     */
    get(  cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export interface IHelloWorldClient {
    /**
     * @return OK
     */
    getAll(): Promise<string[]>;
    /**
     * @return No Content
     */
    post(value: string): Promise<void>;
    /**
     * @return OK
     */
    get(id: number): Promise<string>;
    /**
     * @return No Content
     */
    put(id: number, value: string): Promise<void>;
    /**
     * @return No Content
     */
    delete(id: number): Promise<void>;
}

export class HelloWorldClient implements IHelloWorldClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44326";

    }

    /**
     * @return OK
     */
    getAll(  cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/HelloWorld";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * @return No Content
     */
    post(value: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/HelloWorld";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return OK
     */
    get(id: number , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/HelloWorld/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return No Content
     */
    put(id: number, value: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/HelloWorld/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No Content
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/HelloWorld/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export interface IResultClient {
    /**
     * Add Result Collection.  This is used by Unit Standard.
     * @return OK
     */
    post(requestList: CreateResultRequestDto[]): Promise<ApiResultOfIListOfCreateResultResponseDto>;
    /**
     * Search Results.
     * @param dateEnteredFrom (optional)
     * @param dateEnteredTo (optional)
     * @return OK
     */
    get(dateEnteredFrom?: string | null | undefined, dateEnteredTo?: string | null | undefined): Promise<ApiResultOfIEnumerableOfResultDto>;
    /**
     * Add Result. This is used by Casual Credit, saving single result
     * @return OK
     */
    post2(request: CreateResultRequestDto): Promise<ApiResultOfCreateResultResponseDto>;
}

export class ResultClient implements IResultClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44326";

    }

    /**
     * Add Result Collection.  This is used by Unit Standard.
     * @return OK
     */
    post(requestList: CreateResultRequestDto[] , cancelToken?: CancelToken | undefined): Promise<ApiResultOfIListOfCreateResultResponseDto> {
        let url_ = this.baseUrl + "/api/result/multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestList);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<ApiResultOfIListOfCreateResultResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfIListOfCreateResultResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResultOfIListOfCreateResultResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfIListOfCreateResultResponseDto>(<any>null);
    }

    /**
     * Search Results.
     * @param dateEnteredFrom (optional)
     * @param dateEnteredTo (optional)
     * @return OK
     */
    get(dateEnteredFrom?: string | null | undefined, dateEnteredTo?: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<ApiResultOfIEnumerableOfResultDto> {
        let url_ = this.baseUrl + "/api/Result?";
        if (dateEnteredFrom !== undefined && dateEnteredFrom !== null)
            url_ += "DateEnteredFrom=" + encodeURIComponent("" + dateEnteredFrom) + "&";
        if (dateEnteredTo !== undefined && dateEnteredTo !== null)
            url_ += "DateEnteredTo=" + encodeURIComponent("" + dateEnteredTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ApiResultOfIEnumerableOfResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfIEnumerableOfResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResultOfIEnumerableOfResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfIEnumerableOfResultDto>(<any>null);
    }

    /**
     * Add Result. This is used by Casual Credit, saving single result
     * @return OK
     */
    post2(request: CreateResultRequestDto , cancelToken?: CancelToken | undefined): Promise<ApiResultOfCreateResultResponseDto> {
        let url_ = this.baseUrl + "/api/Result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost2(_response);
        });
    }

    protected processPost2(response: AxiosResponse): Promise<ApiResultOfCreateResultResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfCreateResultResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResultOfCreateResultResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCreateResultResponseDto>(<any>null);
    }
}

export interface IScopeClient {
    /**
     * Search scopes.
     * @param unitStandard (optional)
     * @return OK
     */
    get(unitStandard?: string | null | undefined): Promise<SearchScopeResultDto>;
}

export class ScopeClient implements IScopeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44326";

    }

    /**
     * Search scopes.
     * @param unitStandard (optional)
     * @return OK
     */
    get(unitStandard?: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SearchScopeResultDto> {
        let url_ = this.baseUrl + "/api/Scope?";
        if (unitStandard !== undefined && unitStandard !== null)
            url_ += "UnitStandard=" + encodeURIComponent("" + unitStandard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SearchScopeResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchScopeResultDto.fromJS(resultData200);
            return Promise.resolve<SearchScopeResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchScopeResultDto>(<any>null);
    }
}

export interface ITraineeClient {
    /**
     * Create new trainee
     * @param fName First Name
     * @param lName Last Name
     * @param dob Date of Birth
     * @param gender Gender
     * @param proofFile Proof of Identity
     * @return OK
     */
    create(fName: string, lName: string, dob: string, gender: string, proofFile: FileParameter): Promise<ApiResultOfContact>;
}

export class TraineeClient implements ITraineeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44326";

    }

    /**
     * Create new trainee
     * @param fName First Name
     * @param lName Last Name
     * @param dob Date of Birth
     * @param gender Gender
     * @param proofFile Proof of Identity
     * @return OK
     */
    create(fName: string, lName: string, dob: string, gender: string, proofFile: FileParameter , cancelToken?: CancelToken | undefined): Promise<ApiResultOfContact> {
        let url_ = this.baseUrl + "/api/trainee/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fName === null || fName === undefined)
            throw new Error("The parameter 'fName' cannot be null.");
        else
            content_.append("fName", fName.toString());
        if (lName === null || lName === undefined)
            throw new Error("The parameter 'lName' cannot be null.");
        else
            content_.append("lName", lName.toString());
        if (dob === null || dob === undefined)
            throw new Error("The parameter 'dob' cannot be null.");
        else
            content_.append("dob", dob.toString());
        if (gender === null || gender === undefined)
            throw new Error("The parameter 'gender' cannot be null.");
        else
            content_.append("gender", gender.toString());
        if (proofFile === null || proofFile === undefined)
            throw new Error("The parameter 'proofFile' cannot be null.");
        else
            content_.append("proofFile", proofFile.data, proofFile.fileName ? proofFile.fileName : "proofFile");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApiResultOfContact> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfContact.fromJS(resultData200);
            return Promise.resolve<ApiResultOfContact>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfContact>(<any>null);
    }
}

export interface ITrainingPlanClient {
    /**
     * Gets a list of all training plans where logged in user is the assessor
     * @return OK
     */
    myTrainingPlans(): Promise<TrainingPlanDto[]>;
    /**
     * Search training plans where {query} is matched against either of Training Plan ID, NSN or Name
     * @param query search string
     * @param includeEmptyTrainee (optional)
     * @return OK
     */
    searchTrainingPlans(query: string, includeEmptyTrainee?: boolean | null | undefined): Promise<TrainingPlanDto[]>;
}

export class TrainingPlanClient implements ITrainingPlanClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44326";

    }

    /**
     * Gets a list of all training plans where logged in user is the assessor
     * @return OK
     */
    myTrainingPlans(  cancelToken?: CancelToken | undefined): Promise<TrainingPlanDto[]> {
        let url_ = this.baseUrl + "/api/trainingplan/my";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMyTrainingPlans(_response);
        });
    }

    protected processMyTrainingPlans(response: AxiosResponse): Promise<TrainingPlanDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingPlanDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TrainingPlanDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingPlanDto[]>(<any>null);
    }

    /**
     * Search training plans where {query} is matched against either of Training Plan ID, NSN or Name
     * @param query search string
     * @param includeEmptyTrainee (optional)
     * @return OK
     */
    searchTrainingPlans(query: string, includeEmptyTrainee?: boolean | null | undefined , cancelToken?: CancelToken | undefined): Promise<TrainingPlanDto[]> {
        let url_ = this.baseUrl + "/api/trainingplan/search?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (includeEmptyTrainee !== undefined && includeEmptyTrainee !== null)
            url_ += "includeEmptyTrainee=" + encodeURIComponent("" + includeEmptyTrainee) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchTrainingPlans(_response);
        });
    }

    protected processSearchTrainingPlans(response: AxiosResponse): Promise<TrainingPlanDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingPlanDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TrainingPlanDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingPlanDto[]>(<any>null);
    }
}

export interface ITrainingPlanUnitStandardClient {
    /**
     * Search training plan unit standards.
     * @param trainingPlanId (optional)
     * @return OK
     */
    get(trainingPlanId?: string | null | undefined): Promise<TrainingPlanUnitStandardDto[]>;
}

export class TrainingPlanUnitStandardClient implements ITrainingPlanUnitStandardClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44326";

    }

    /**
     * Search training plan unit standards.
     * @param trainingPlanId (optional)
     * @return OK
     */
    get(trainingPlanId?: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<TrainingPlanUnitStandardDto[]> {
        let url_ = this.baseUrl + "/api/TrainingPlanUnitStandard?";
        if (trainingPlanId !== undefined && trainingPlanId !== null)
            url_ += "TrainingPlanId=" + encodeURIComponent("" + trainingPlanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TrainingPlanUnitStandardDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingPlanUnitStandardDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TrainingPlanUnitStandardDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingPlanUnitStandardDto[]>(<any>null);
    }
}

export interface IUnitStandardClient {
    /**
     * @return OK
     */
    get(code: number): Promise<ApiResultOfUnitStandardDto>;
}

export class UnitStandardClient implements IUnitStandardClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44326";

    }

    /**
     * @return OK
     */
    get(code: number , cancelToken?: CancelToken | undefined): Promise<ApiResultOfUnitStandardDto> {
        let url_ = this.baseUrl + "/api/UnitStandard?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ApiResultOfUnitStandardDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfUnitStandardDto.fromJS(resultData200);
            return Promise.resolve<ApiResultOfUnitStandardDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("NotFound", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfUnitStandardDto>(<any>null);
    }
}

export interface IUnitStandardVersionClient {
    /**
     * @return OK
     */
    get(code: number): Promise<ApiResultOfUnitStandardVersionsDto>;
}

export class UnitStandardVersionClient implements IUnitStandardVersionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44326";

    }

    /**
     * @return OK
     */
    get(code: number , cancelToken?: CancelToken | undefined): Promise<ApiResultOfUnitStandardVersionsDto> {
        let url_ = this.baseUrl + "/api/UnitStandardVersion?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ApiResultOfUnitStandardVersionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultOfUnitStandardVersionsDto.fromJS(resultData200);
            return Promise.resolve<ApiResultOfUnitStandardVersionsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("NotFound", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfUnitStandardVersionsDto>(<any>null);
    }
}

export class ApiResultOfIEnumerableOfAccountDto implements IApiResultOfIEnumerableOfAccountDto {
    result?: AccountDto[] | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfIEnumerableOfAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.result) {
                this.result = [];
                for (let i = 0; i < data.result.length; i++) {
                    let item = data.result[i];
                    this.result[i] = item && !(<any>item).toJSON ? new AccountDto(item) : <AccountDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(AccountDto.fromJS(item));
            }
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ApiResultOfIEnumerableOfAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfIEnumerableOfAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfIEnumerableOfAccountDto {
        const json = this.toJSON();
        let result = new ApiResultOfIEnumerableOfAccountDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfIEnumerableOfAccountDto {
    result?: IAccountDto[] | undefined;
    message?: string | undefined;
}

export class AccountDto implements IAccountDto {
    accountName?: string | undefined;
    debtorNumber?: string | undefined;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["AccountName"];
            this.debtorNumber = _data["DebtorNumber"];
        }
    }

    static fromJS(data: any): AccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountName"] = this.accountName;
        data["DebtorNumber"] = this.debtorNumber;
        return data;
    }

    clone(): AccountDto {
        const json = this.toJSON();
        let result = new AccountDto();
        result.init(json);
        return result;
    }
}

export interface IAccountDto {
    accountName?: string | undefined;
    debtorNumber?: string | undefined;
}

export class CreateResultRequestDto implements ICreateResultRequestDto {
    assessorId?: string | undefined;
    traineeId?: string | undefined;
    unitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    isExistingResult?: boolean | undefined;
    dateAchieved?: string | undefined;
    dateEntered?: string | undefined;
    statusCode?: number | undefined;
    isRcc?: boolean | undefined;
    casualCredit?: boolean | undefined;
    debtorCode?: string | undefined;
    poNumber?: string | undefined;

    constructor(data?: ICreateResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessorId = _data["AssessorId"];
            this.traineeId = _data["TraineeId"];
            this.unitStandardId = _data["UnitStandardId"];
            this.unitStandardCode = _data["UnitStandardCode"];
            this.unitStandardName = _data["UnitStandardName"];
            this.isExistingResult = _data["IsExistingResult"];
            this.dateAchieved = _data["DateAchieved"];
            this.dateEntered = _data["DateEntered"];
            this.statusCode = _data["StatusCode"];
            this.isRcc = _data["IsRcc"];
            this.casualCredit = _data["CasualCredit"];
            this.debtorCode = _data["DebtorCode"];
            this.poNumber = _data["PoNumber"];
        }
    }

    static fromJS(data: any): CreateResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssessorId"] = this.assessorId;
        data["TraineeId"] = this.traineeId;
        data["UnitStandardId"] = this.unitStandardId;
        data["UnitStandardCode"] = this.unitStandardCode;
        data["UnitStandardName"] = this.unitStandardName;
        data["IsExistingResult"] = this.isExistingResult;
        data["DateAchieved"] = this.dateAchieved;
        data["DateEntered"] = this.dateEntered;
        data["StatusCode"] = this.statusCode;
        data["IsRcc"] = this.isRcc;
        data["CasualCredit"] = this.casualCredit;
        data["DebtorCode"] = this.debtorCode;
        data["PoNumber"] = this.poNumber;
        return data;
    }

    clone(): CreateResultRequestDto {
        const json = this.toJSON();
        let result = new CreateResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICreateResultRequestDto {
    assessorId?: string | undefined;
    traineeId?: string | undefined;
    unitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    isExistingResult?: boolean | undefined;
    dateAchieved?: string | undefined;
    dateEntered?: string | undefined;
    statusCode?: number | undefined;
    isRcc?: boolean | undefined;
    casualCredit?: boolean | undefined;
    debtorCode?: string | undefined;
    poNumber?: string | undefined;
}

export class ApiResultOfIListOfCreateResultResponseDto implements IApiResultOfIListOfCreateResultResponseDto {
    result?: CreateResultResponseDto[] | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfIListOfCreateResultResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.result) {
                this.result = [];
                for (let i = 0; i < data.result.length; i++) {
                    let item = data.result[i];
                    this.result[i] = item && !(<any>item).toJSON ? new CreateResultResponseDto(item) : <CreateResultResponseDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(CreateResultResponseDto.fromJS(item));
            }
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ApiResultOfIListOfCreateResultResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfIListOfCreateResultResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfIListOfCreateResultResponseDto {
        const json = this.toJSON();
        let result = new ApiResultOfIListOfCreateResultResponseDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfIListOfCreateResultResponseDto {
    result?: ICreateResultResponseDto[] | undefined;
    message?: string | undefined;
}

export class CreateResultResponseDto implements ICreateResultResponseDto {
    resultId?: string | undefined;
    crmSaveErrorMessage?: string | undefined;
    crmSaveStatus?: CreateResultResponseDtoCrmSaveStatus | undefined;
    assessorId?: string | undefined;
    traineeId?: string | undefined;
    unitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    isExistingResult?: boolean | undefined;
    dateAchieved?: string | undefined;
    dateEntered?: string | undefined;
    statusCode?: number | undefined;
    isRcc?: boolean | undefined;
    casualCredit?: boolean | undefined;
    debtorCode?: string | undefined;
    poNumber?: string | undefined;

    constructor(data?: ICreateResultResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultId = _data["ResultId"];
            this.crmSaveErrorMessage = _data["CrmSaveErrorMessage"];
            this.crmSaveStatus = _data["CrmSaveStatus"];
            this.assessorId = _data["AssessorId"];
            this.traineeId = _data["TraineeId"];
            this.unitStandardId = _data["UnitStandardId"];
            this.unitStandardCode = _data["UnitStandardCode"];
            this.unitStandardName = _data["UnitStandardName"];
            this.isExistingResult = _data["IsExistingResult"];
            this.dateAchieved = _data["DateAchieved"];
            this.dateEntered = _data["DateEntered"];
            this.statusCode = _data["StatusCode"];
            this.isRcc = _data["IsRcc"];
            this.casualCredit = _data["CasualCredit"];
            this.debtorCode = _data["DebtorCode"];
            this.poNumber = _data["PoNumber"];
        }
    }

    static fromJS(data: any): CreateResultResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResultResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResultId"] = this.resultId;
        data["CrmSaveErrorMessage"] = this.crmSaveErrorMessage;
        data["CrmSaveStatus"] = this.crmSaveStatus;
        data["AssessorId"] = this.assessorId;
        data["TraineeId"] = this.traineeId;
        data["UnitStandardId"] = this.unitStandardId;
        data["UnitStandardCode"] = this.unitStandardCode;
        data["UnitStandardName"] = this.unitStandardName;
        data["IsExistingResult"] = this.isExistingResult;
        data["DateAchieved"] = this.dateAchieved;
        data["DateEntered"] = this.dateEntered;
        data["StatusCode"] = this.statusCode;
        data["IsRcc"] = this.isRcc;
        data["CasualCredit"] = this.casualCredit;
        data["DebtorCode"] = this.debtorCode;
        data["PoNumber"] = this.poNumber;
        return data;
    }

    clone(): CreateResultResponseDto {
        const json = this.toJSON();
        let result = new CreateResultResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateResultResponseDto {
    resultId?: string | undefined;
    crmSaveErrorMessage?: string | undefined;
    crmSaveStatus?: CreateResultResponseDtoCrmSaveStatus | undefined;
    assessorId?: string | undefined;
    traineeId?: string | undefined;
    unitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    isExistingResult?: boolean | undefined;
    dateAchieved?: string | undefined;
    dateEntered?: string | undefined;
    statusCode?: number | undefined;
    isRcc?: boolean | undefined;
    casualCredit?: boolean | undefined;
    debtorCode?: string | undefined;
    poNumber?: string | undefined;
}

export class ApiResultOfIEnumerableOfResultDto implements IApiResultOfIEnumerableOfResultDto {
    result?: ResultDto[] | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfIEnumerableOfResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.result) {
                this.result = [];
                for (let i = 0; i < data.result.length; i++) {
                    let item = data.result[i];
                    this.result[i] = item && !(<any>item).toJSON ? new ResultDto(item) : <ResultDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(ResultDto.fromJS(item));
            }
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ApiResultOfIEnumerableOfResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfIEnumerableOfResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfIEnumerableOfResultDto {
        const json = this.toJSON();
        let result = new ApiResultOfIEnumerableOfResultDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfIEnumerableOfResultDto {
    result?: IResultDto[] | undefined;
    message?: string | undefined;
}

export class ResultDto implements IResultDto {
    resultId?: string | undefined;
    dateEntered?: string | undefined;
    dateAchieved?: string | undefined;
    trainingPlanId?: string | undefined;
    frameworkElementCode?: string | undefined;
    traineeId?: string | undefined;
    traineeFirstName?: string | undefined;
    traineeLastName?: string | undefined;
    traineeNSN?: string | undefined;

    constructor(data?: IResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultId = _data["ResultId"];
            this.dateEntered = _data["DateEntered"];
            this.dateAchieved = _data["DateAchieved"];
            this.trainingPlanId = _data["TrainingPlanId"];
            this.frameworkElementCode = _data["FrameworkElementCode"];
            this.traineeId = _data["TraineeId"];
            this.traineeFirstName = _data["TraineeFirstName"];
            this.traineeLastName = _data["TraineeLastName"];
            this.traineeNSN = _data["TraineeNSN"];
        }
    }

    static fromJS(data: any): ResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResultId"] = this.resultId;
        data["DateEntered"] = this.dateEntered;
        data["DateAchieved"] = this.dateAchieved;
        data["TrainingPlanId"] = this.trainingPlanId;
        data["FrameworkElementCode"] = this.frameworkElementCode;
        data["TraineeId"] = this.traineeId;
        data["TraineeFirstName"] = this.traineeFirstName;
        data["TraineeLastName"] = this.traineeLastName;
        data["TraineeNSN"] = this.traineeNSN;
        return data;
    }

    clone(): ResultDto {
        const json = this.toJSON();
        let result = new ResultDto();
        result.init(json);
        return result;
    }
}

export interface IResultDto {
    resultId?: string | undefined;
    dateEntered?: string | undefined;
    dateAchieved?: string | undefined;
    trainingPlanId?: string | undefined;
    frameworkElementCode?: string | undefined;
    traineeId?: string | undefined;
    traineeFirstName?: string | undefined;
    traineeLastName?: string | undefined;
    traineeNSN?: string | undefined;
}

export class ApiResultOfCreateResultResponseDto implements IApiResultOfCreateResultResponseDto {
    result?: CreateResultResponseDto | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfCreateResultResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new CreateResultResponseDto(data.result) : <CreateResultResponseDto>this.result;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? CreateResultResponseDto.fromJS(_data["Result"]) : <any>undefined;
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ApiResultOfCreateResultResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfCreateResultResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfCreateResultResponseDto {
        const json = this.toJSON();
        let result = new ApiResultOfCreateResultResponseDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfCreateResultResponseDto {
    result?: ICreateResultResponseDto | undefined;
    message?: string | undefined;
}

export class SearchScopeResultDto implements ISearchScopeResultDto {
    scopes?: ScopeDto[] | undefined;

    constructor(data?: ISearchScopeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.scopes) {
                this.scopes = [];
                for (let i = 0; i < data.scopes.length; i++) {
                    let item = data.scopes[i];
                    this.scopes[i] = item && !(<any>item).toJSON ? new ScopeDto(item) : <ScopeDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["Scopes"])
                    this.scopes!.push(ScopeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchScopeResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchScopeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scopes)) {
            data["Scopes"] = [];
            for (let item of this.scopes)
                data["Scopes"].push(item.toJSON());
        }
        return data;
    }

    clone(): SearchScopeResultDto {
        const json = this.toJSON();
        let result = new SearchScopeResultDto();
        result.init(json);
        return result;
    }
}

export interface ISearchScopeResultDto {
    scopes?: IScopeDto[] | undefined;
}

export class ScopeDto implements IScopeDto {
    assessorRegistrationId?: string | undefined;
    assessmentScopeId?: string | undefined;
    supplementaryUnitStandardId?: string | undefined;
    name?: string | undefined;
    parentFrameworkElements?: ParentFrameworkElement[] | undefined;

    constructor(data?: IScopeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.parentFrameworkElements) {
                this.parentFrameworkElements = [];
                for (let i = 0; i < data.parentFrameworkElements.length; i++) {
                    let item = data.parentFrameworkElements[i];
                    this.parentFrameworkElements[i] = item && !(<any>item).toJSON ? new ParentFrameworkElement(item) : <ParentFrameworkElement>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessorRegistrationId = _data["AssessorRegistrationId"];
            this.assessmentScopeId = _data["AssessmentScopeId"];
            this.supplementaryUnitStandardId = _data["SupplementaryUnitStandardId"];
            this.name = _data["Name"];
            if (Array.isArray(_data["ParentFrameworkElements"])) {
                this.parentFrameworkElements = [] as any;
                for (let item of _data["ParentFrameworkElements"])
                    this.parentFrameworkElements!.push(ParentFrameworkElement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScopeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssessorRegistrationId"] = this.assessorRegistrationId;
        data["AssessmentScopeId"] = this.assessmentScopeId;
        data["SupplementaryUnitStandardId"] = this.supplementaryUnitStandardId;
        data["Name"] = this.name;
        if (Array.isArray(this.parentFrameworkElements)) {
            data["ParentFrameworkElements"] = [];
            for (let item of this.parentFrameworkElements)
                data["ParentFrameworkElements"].push(item.toJSON());
        }
        return data;
    }

    clone(): ScopeDto {
        const json = this.toJSON();
        let result = new ScopeDto();
        result.init(json);
        return result;
    }
}

export interface IScopeDto {
    assessorRegistrationId?: string | undefined;
    assessmentScopeId?: string | undefined;
    supplementaryUnitStandardId?: string | undefined;
    name?: string | undefined;
    parentFrameworkElements?: IParentFrameworkElement[] | undefined;
}

export class ParentFrameworkElement implements IParentFrameworkElement {
    name?: string | undefined;
    unitStandards?: UnitStandard[] | undefined;

    constructor(data?: IParentFrameworkElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.unitStandards) {
                this.unitStandards = [];
                for (let i = 0; i < data.unitStandards.length; i++) {
                    let item = data.unitStandards[i];
                    this.unitStandards[i] = item && !(<any>item).toJSON ? new UnitStandard(item) : <UnitStandard>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            if (Array.isArray(_data["UnitStandards"])) {
                this.unitStandards = [] as any;
                for (let item of _data["UnitStandards"])
                    this.unitStandards!.push(UnitStandard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParentFrameworkElement {
        data = typeof data === 'object' ? data : {};
        let result = new ParentFrameworkElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        if (Array.isArray(this.unitStandards)) {
            data["UnitStandards"] = [];
            for (let item of this.unitStandards)
                data["UnitStandards"].push(item.toJSON());
        }
        return data;
    }

    clone(): ParentFrameworkElement {
        const json = this.toJSON();
        let result = new ParentFrameworkElement();
        result.init(json);
        return result;
    }
}

export interface IParentFrameworkElement {
    name?: string | undefined;
    unitStandards?: IUnitStandard[] | undefined;
}

export class UnitStandard implements IUnitStandard {
    unitStandardId?: string | undefined;
    frameworkElementId?: string | undefined;
    frameworkElementCode?: string | undefined;
    unitStandardName?: string | undefined;
    credits?: number | undefined;
    currentVersion?: number | undefined;
    versions?: string | undefined;
    isLatestVersion?: boolean | undefined;
    readonly entityName?: string | undefined;

    constructor(data?: IUnitStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitStandardId = _data["UnitStandardId"];
            this.frameworkElementId = _data["FrameworkElementId"];
            this.frameworkElementCode = _data["FrameworkElementCode"];
            this.unitStandardName = _data["UnitStandardName"];
            this.credits = _data["Credits"];
            this.currentVersion = _data["CurrentVersion"];
            this.versions = _data["Versions"];
            this.isLatestVersion = _data["IsLatestVersion"];
            (<any>this).entityName = _data["EntityName"];
        }
    }

    static fromJS(data: any): UnitStandard {
        data = typeof data === 'object' ? data : {};
        let result = new UnitStandard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UnitStandardId"] = this.unitStandardId;
        data["FrameworkElementId"] = this.frameworkElementId;
        data["FrameworkElementCode"] = this.frameworkElementCode;
        data["UnitStandardName"] = this.unitStandardName;
        data["Credits"] = this.credits;
        data["CurrentVersion"] = this.currentVersion;
        data["Versions"] = this.versions;
        data["IsLatestVersion"] = this.isLatestVersion;
        data["EntityName"] = this.entityName;
        return data;
    }

    clone(): UnitStandard {
        const json = this.toJSON();
        let result = new UnitStandard();
        result.init(json);
        return result;
    }
}

export interface IUnitStandard {
    unitStandardId?: string | undefined;
    frameworkElementId?: string | undefined;
    frameworkElementCode?: string | undefined;
    unitStandardName?: string | undefined;
    credits?: number | undefined;
    currentVersion?: number | undefined;
    versions?: string | undefined;
    isLatestVersion?: boolean | undefined;
    entityName?: string | undefined;
}

export class ApiResultOfContact implements IApiResultOfContact {
    result?: Contact | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new Contact(data.result) : <Contact>this.result;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? Contact.fromJS(_data["Result"]) : <any>undefined;
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ApiResultOfContact {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfContact {
        const json = this.toJSON();
        let result = new ApiResultOfContact();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfContact {
    result?: IContact | undefined;
    message?: string | undefined;
}

export class Contact implements IContact {
    id?: string | undefined;
    azureId?: string | undefined;
    allowPortalAccess?: boolean | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    jobTitle?: string | undefined;
    nSN?: string | undefined;
    dateOfBirth?: string | undefined;
    gender?: number | undefined;
    isTrainee?: boolean | undefined;
    readonly entityName?: string | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.azureId = _data["AzureId"];
            this.allowPortalAccess = _data["AllowPortalAccess"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.email = _data["Email"];
            this.jobTitle = _data["JobTitle"];
            this.nSN = _data["NSN"];
            this.dateOfBirth = _data["DateOfBirth"];
            this.gender = _data["Gender"];
            this.isTrainee = _data["IsTrainee"];
            (<any>this).entityName = _data["EntityName"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AzureId"] = this.azureId;
        data["AllowPortalAccess"] = this.allowPortalAccess;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Email"] = this.email;
        data["JobTitle"] = this.jobTitle;
        data["NSN"] = this.nSN;
        data["DateOfBirth"] = this.dateOfBirth;
        data["Gender"] = this.gender;
        data["IsTrainee"] = this.isTrainee;
        data["EntityName"] = this.entityName;
        return data;
    }

    clone(): Contact {
        const json = this.toJSON();
        let result = new Contact();
        result.init(json);
        return result;
    }
}

export interface IContact {
    id?: string | undefined;
    azureId?: string | undefined;
    allowPortalAccess?: boolean | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    jobTitle?: string | undefined;
    nSN?: string | undefined;
    dateOfBirth?: string | undefined;
    gender?: number | undefined;
    isTrainee?: boolean | undefined;
    entityName?: string | undefined;
}

export class TrainingPlanDto implements ITrainingPlanDto {
    contactId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nSN?: string | undefined;
    trainingPlanId?: string | undefined;
    programmeName?: string | undefined;
    isTtafEligible?: boolean | undefined;
    dateOfBirth?: string | undefined;
    status?: string | undefined;

    constructor(data?: ITrainingPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["ContactId"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.nSN = _data["NSN"];
            this.trainingPlanId = _data["TrainingPlanId"];
            this.programmeName = _data["ProgrammeName"];
            this.isTtafEligible = _data["IsTtafEligible"];
            this.dateOfBirth = _data["DateOfBirth"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): TrainingPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContactId"] = this.contactId;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["NSN"] = this.nSN;
        data["TrainingPlanId"] = this.trainingPlanId;
        data["ProgrammeName"] = this.programmeName;
        data["IsTtafEligible"] = this.isTtafEligible;
        data["DateOfBirth"] = this.dateOfBirth;
        data["Status"] = this.status;
        return data;
    }

    clone(): TrainingPlanDto {
        const json = this.toJSON();
        let result = new TrainingPlanDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingPlanDto {
    contactId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nSN?: string | undefined;
    trainingPlanId?: string | undefined;
    programmeName?: string | undefined;
    isTtafEligible?: boolean | undefined;
    dateOfBirth?: string | undefined;
    status?: string | undefined;
}

export class TrainingPlanUnitStandardDto implements ITrainingPlanUnitStandardDto {
    trainingPlanId?: string | undefined;
    trainingPlanUnitStandards?: TrainingPlanUnitStandard[] | undefined;

    constructor(data?: ITrainingPlanUnitStandardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.trainingPlanUnitStandards) {
                this.trainingPlanUnitStandards = [];
                for (let i = 0; i < data.trainingPlanUnitStandards.length; i++) {
                    let item = data.trainingPlanUnitStandards[i];
                    this.trainingPlanUnitStandards[i] = item && !(<any>item).toJSON ? new TrainingPlanUnitStandard(item) : <TrainingPlanUnitStandard>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingPlanId = _data["TrainingPlanId"];
            if (Array.isArray(_data["TrainingPlanUnitStandards"])) {
                this.trainingPlanUnitStandards = [] as any;
                for (let item of _data["TrainingPlanUnitStandards"])
                    this.trainingPlanUnitStandards!.push(TrainingPlanUnitStandard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainingPlanUnitStandardDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingPlanUnitStandardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TrainingPlanId"] = this.trainingPlanId;
        if (Array.isArray(this.trainingPlanUnitStandards)) {
            data["TrainingPlanUnitStandards"] = [];
            for (let item of this.trainingPlanUnitStandards)
                data["TrainingPlanUnitStandards"].push(item.toJSON());
        }
        return data;
    }

    clone(): TrainingPlanUnitStandardDto {
        const json = this.toJSON();
        let result = new TrainingPlanUnitStandardDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingPlanUnitStandardDto {
    trainingPlanId?: string | undefined;
    trainingPlanUnitStandards?: ITrainingPlanUnitStandard[] | undefined;
}

export class TrainingPlanUnitStandard implements ITrainingPlanUnitStandard {
    unitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    resultId?: string | undefined;
    dateAchieved?: string | undefined;
    isRcc?: boolean | undefined;
    readonly isExistingResult?: boolean | undefined;
    readonly entityName?: string | undefined;

    constructor(data?: ITrainingPlanUnitStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitStandardId = _data["UnitStandardId"];
            this.unitStandardCode = _data["UnitStandardCode"];
            this.unitStandardName = _data["UnitStandardName"];
            this.resultId = _data["ResultId"];
            this.dateAchieved = _data["DateAchieved"];
            this.isRcc = _data["IsRcc"];
            (<any>this).isExistingResult = _data["IsExistingResult"];
            (<any>this).entityName = _data["EntityName"];
        }
    }

    static fromJS(data: any): TrainingPlanUnitStandard {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingPlanUnitStandard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UnitStandardId"] = this.unitStandardId;
        data["UnitStandardCode"] = this.unitStandardCode;
        data["UnitStandardName"] = this.unitStandardName;
        data["ResultId"] = this.resultId;
        data["DateAchieved"] = this.dateAchieved;
        data["IsRcc"] = this.isRcc;
        data["IsExistingResult"] = this.isExistingResult;
        data["EntityName"] = this.entityName;
        return data;
    }

    clone(): TrainingPlanUnitStandard {
        const json = this.toJSON();
        let result = new TrainingPlanUnitStandard();
        result.init(json);
        return result;
    }
}

export interface ITrainingPlanUnitStandard {
    unitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    resultId?: string | undefined;
    dateAchieved?: string | undefined;
    isRcc?: boolean | undefined;
    isExistingResult?: boolean | undefined;
    entityName?: string | undefined;
}

export class ApiResultOfUnitStandardDto implements IApiResultOfUnitStandardDto {
    result?: UnitStandardDto | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfUnitStandardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new UnitStandardDto(data.result) : <UnitStandardDto>this.result;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? UnitStandardDto.fromJS(_data["Result"]) : <any>undefined;
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ApiResultOfUnitStandardDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfUnitStandardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfUnitStandardDto {
        const json = this.toJSON();
        let result = new ApiResultOfUnitStandardDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfUnitStandardDto {
    result?: IUnitStandardDto | undefined;
    message?: string | undefined;
}

export class UnitStandardDto implements IUnitStandardDto {
    frameworkElementId?: string | undefined;
    unitStandardId?: string | undefined;
    frameworkElementCode?: string | undefined;
    unitStandardName?: string | undefined;
    credits?: number | undefined;
    currentVersion?: number | undefined;
    versions?: string | undefined;
    isLatestVersion?: boolean | undefined;

    constructor(data?: IUnitStandardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.frameworkElementId = _data["FrameworkElementId"];
            this.unitStandardId = _data["UnitStandardId"];
            this.frameworkElementCode = _data["FrameworkElementCode"];
            this.unitStandardName = _data["UnitStandardName"];
            this.credits = _data["Credits"];
            this.currentVersion = _data["CurrentVersion"];
            this.versions = _data["Versions"];
            this.isLatestVersion = _data["IsLatestVersion"];
        }
    }

    static fromJS(data: any): UnitStandardDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitStandardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FrameworkElementId"] = this.frameworkElementId;
        data["UnitStandardId"] = this.unitStandardId;
        data["FrameworkElementCode"] = this.frameworkElementCode;
        data["UnitStandardName"] = this.unitStandardName;
        data["Credits"] = this.credits;
        data["CurrentVersion"] = this.currentVersion;
        data["Versions"] = this.versions;
        data["IsLatestVersion"] = this.isLatestVersion;
        return data;
    }

    clone(): UnitStandardDto {
        const json = this.toJSON();
        let result = new UnitStandardDto();
        result.init(json);
        return result;
    }
}

export interface IUnitStandardDto {
    frameworkElementId?: string | undefined;
    unitStandardId?: string | undefined;
    frameworkElementCode?: string | undefined;
    unitStandardName?: string | undefined;
    credits?: number | undefined;
    currentVersion?: number | undefined;
    versions?: string | undefined;
    isLatestVersion?: boolean | undefined;
}

export class ApiResultOfUnitStandardVersionsDto implements IApiResultOfUnitStandardVersionsDto {
    result?: UnitStandardVersionsDto | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfUnitStandardVersionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new UnitStandardVersionsDto(data.result) : <UnitStandardVersionsDto>this.result;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? UnitStandardVersionsDto.fromJS(_data["Result"]) : <any>undefined;
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): ApiResultOfUnitStandardVersionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultOfUnitStandardVersionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfUnitStandardVersionsDto {
        const json = this.toJSON();
        let result = new ApiResultOfUnitStandardVersionsDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfUnitStandardVersionsDto {
    result?: IUnitStandardVersionsDto | undefined;
    message?: string | undefined;
}

export class UnitStandardVersionsDto implements IUnitStandardVersionsDto {
    frameworkElementCode?: string | undefined;
    versions?: VersionDto[] | undefined;

    constructor(data?: IUnitStandardVersionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.versions) {
                this.versions = [];
                for (let i = 0; i < data.versions.length; i++) {
                    let item = data.versions[i];
                    this.versions[i] = item && !(<any>item).toJSON ? new VersionDto(item) : <VersionDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.frameworkElementCode = _data["FrameworkElementCode"];
            if (Array.isArray(_data["Versions"])) {
                this.versions = [] as any;
                for (let item of _data["Versions"])
                    this.versions!.push(VersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitStandardVersionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitStandardVersionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FrameworkElementCode"] = this.frameworkElementCode;
        if (Array.isArray(this.versions)) {
            data["Versions"] = [];
            for (let item of this.versions)
                data["Versions"].push(item.toJSON());
        }
        return data;
    }

    clone(): UnitStandardVersionsDto {
        const json = this.toJSON();
        let result = new UnitStandardVersionsDto();
        result.init(json);
        return result;
    }
}

export interface IUnitStandardVersionsDto {
    frameworkElementCode?: string | undefined;
    versions?: IVersionDto[] | undefined;
}

export class VersionDto implements IVersionDto {
    unitStandardId?: string | undefined;
    version?: number | undefined;

    constructor(data?: IVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitStandardId = _data["UnitStandardId"];
            this.version = _data["Version"];
        }
    }

    static fromJS(data: any): VersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UnitStandardId"] = this.unitStandardId;
        data["Version"] = this.version;
        return data;
    }

    clone(): VersionDto {
        const json = this.toJSON();
        let result = new VersionDto();
        result.init(json);
        return result;
    }
}

export interface IVersionDto {
    unitStandardId?: string | undefined;
    version?: number | undefined;
}

export type CreateResultResponseDtoCrmSaveStatus = 0 | 1;

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}